import { api } from "./../../api.js";

import axios from "axios";

const state = {
  filters: {},
  events: {},
  actions: {}
};

const getters = {
  
  getFilters: state => {
    return state.filters;
  },
  getActions: state => {
    return state.actions;
  },
  getEvents: state => {
    return state.events;
  }
 
};

const mutations = {
  setCurrentAction: (state, actions) => {
    state.actions = actions;
  },
  editCurrentAction: (state, splice_) => {
    state.actions.splice(splice_.start, splice_.end);
  },
  setCurrentEvent: (state, events) => {
    state.events = events;
  },
  setCurrentFilter: (state, filt) => {
    state.filters.filters = filt;
  }
  
};


const actions = {
  updateCurrentActionState: function ({ commit }, payload) {
    commit('setCurrentAction', payload)
  },
  getEachFilter: function ({ commit }, params) {
    let temp_ = this.getters.getFilters;
    if(temp_ && temp_.filters && temp_.filters.filter_lines) {
      return (temp_.filters.filter_lines[params.parent_index].conditions.condition_lines[params.index].rule_property_id)
    }
   
  },
  getEachAction: function ({ commit }, params) {
    let temp_ = this.getters.getActions;
    if(temp_) {
      return temp_[params.index]
    }
   
  },
  getAutomationRules_Who: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/automation/taxonomy/filters", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAutomationRules_When: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/automation/taxonomy/events", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAutomationRules_What: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/automation/taxonomy/actions", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAutomationRulesList: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/automation/rules", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAutomationByID: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/automation/rules/" + params.id, params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAutomationRuleSenctence: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/automation/rules/sentence", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createAutomationRules: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/automation/rules", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  editAutomationRule: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/automation/rules/"+params.id , params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  editAutomationRuleStatus: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/automation/rules/"+params.id+"/change-status", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  openAutomationHistory: function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("admin/automation/rules/" + params.id + "/history", params).then((res) => {
        resolve(res)
        
      }).catch(error => {
        console.log(error)
      })
    })
  }
};
export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AutomationModule.js